<style>
.xlTextfield {
    font-size: 44px;
}

.xlTextfield input {
    font-size: 44px;
}
</style>

<template>
  <div>
    <v-toolbar dark dense color="primary">
      <v-btn icon @click="$router.push('/')">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>Meters</v-toolbar-title>

    </v-toolbar>

    <v-bottom-navigation :value="selectedView"
                         dark
                         grow>
      <v-btn @click="switchView(views.metersList)">
        <span>Meters List</span>

        <v-icon>mdi-view-list</v-icon>
      </v-btn>

      <v-btn @click="switchView(views.enterReads)">
        <span>Enter Reads</span>

        <v-icon>mdi-gauge</v-icon>
      </v-btn>
    </v-bottom-navigation>

    <div>
      <p class="my-2 mx-2">
        <span class="text-sm-h6">{{ activeBuilding.name }}</span>, {{ activeBuilding.address }}
      </p>
    </div>

    <v-divider></v-divider>

    <v-row class="mx-2"  v-if="selectedView === views.metersList">
      <v-col cols="12" >
          <v-text-field 
            v-model="searchInput" 
            label="Search"
            clearable
          ></v-text-field>     
      </v-col>
    </v-row>

    <div class="text-center" v-if="isLoading">
      <v-progress-linear :size="70"
                         :width="7"
                         color="primary"
                         indeterminate/>
      <span>Loading...</span>
    </div>

    <meters-list
      v-if="selectedView === views.metersList"
      :meterReads="filteredBuildingMeterReads"
      @gotoMeterRead="gotoMeterRead"
    ></meters-list>

    <enter-read
      ref="enterReadComponent"
      v-else-if="selectedView === views.enterReads"
      :currentMeterRead="currentMeterRead"
      :currentMeterReadIndex="currentMeterReadIndex"
      :meterReads="buildingMeterReads"
      @nextItem="nextItem"
      @previousItem="previousItem"
      @finished="onFinishReads"
    ></enter-read>
  </div>


</template>

<script>

import {mapState, mapActions, mapGetters} from 'vuex';
import MetersList from '../components/meters/MetersList.vue';
import EnterRead from '../components/meters/EnterRead.vue';

export default {
    name: "MetersView",
    components: {
        MetersList,
        EnterRead
    },
    data() {
        return {
            selectedView: 0,
            currentMeterReadIndex: 0,
            isLoading: false,
            searchInput: '',
            views: {
                metersList: 0,
                enterReads: 1 
            }
        }
    },
    async mounted() {
        this.isLoading = true;
        await this.populateReadsFromCache(this.activeBuildingId);
        this.isLoading = false;
    },
    computed: {
        ...mapState([
            'activeBuildingId',
            'reads'
        ]),
        ...mapGetters([
            'activeBuilding'
        ]),
        buildingMeterReads() {
            return this.reads.filter(m => m.buildingId === this.activeBuildingId)
                .sort(function (x, y) {
                    return x.readSequence - y.readSequence;
                });
        },
        filteredBuildingMeterReads() {
          let filteredBuildingMeterReads = this.buildingMeterReads;
          if (this.searchInput){
            filteredBuildingMeterReads = filteredBuildingMeterReads.filter(m => 
              m.location.toLowerCase().includes(this.searchInput.toLowerCase())
              || m.meterCode.toLowerCase().includes(this.searchInput.toLowerCase())
          );
          }
          return filteredBuildingMeterReads;
        },
        currentMeterRead() {
            return this.buildingMeterReads[this.currentMeterReadIndex] || {};
        }
    },
    methods: {
        ...mapActions([
            'populateReadsFromCache',
            'saveRead'
        ]),
        async switchView(newView) {
            if (this.selectedView === this.views.enterReads && newView === this.views.metersList) {
                // Use current data from EnterRead component & Check reference  
                if (!this.$refs.enterReadComponent) return;

                // Call validation before saving
                const isValid = await this.$refs.enterReadComponent.validOrConfirmedRead();
                if (isValid) {
                    this.saveRead(this.$refs.enterReadComponent.currentMeterReadToEdit);
                    this.selectedView = newView;
                }
                return; // If validation fails, don't save and don't switch views
            }
            this.selectedView = newView;          
        },
        findMeterReadIndex(meterRead) {
            return this.buildingMeterReads.findIndex(m => m.meterId === meterRead.meterId);
        },
        gotoMeterRead(meterRead) {
            this.currentMeterReadIndex = this.findMeterReadIndex(meterRead);
            this.switchView(this.views.enterReads);
        },
        nextItem() {
            if (this.currentMeterReadIndex < this.buildingMeterReads.length - 1) {
                this.currentMeterReadIndex++;
            }
        },
        previousItem() {
            if (this.currentMeterReadIndex > 0) {
                this.currentMeterReadIndex--;
            }
        },
        onFinishReads() {
            // Navigate back to meters list when all readings are complete
            this.selectedView = this.views.metersList;
        }
    }
}
</script>

<style scoped>
</style>